<form name="targetForm" [formGroup]="targetForm">
    <section class="sideRight-body">

        <div id="container-header">
            

           
        </div>
    
    <div id="container">
       

            

            
        <div id="contentC">

            

            
            <label>
                <i class="fas fa-asterisk"></i> <b> Entity Name</b>
                <span *ngIf="f.entityname.errors && f.entityname.touched">
                    <span class="required-error" *ngIf="f.entityname.errors.required">
                        (Required)
                    </span>
                    
                </span>
                <input class="black-input opposite-colors" type="text" no-special-chars="#!$%^<>+='"
                 (blur)="trimSpecialChar('entityname');" 
                 (keyup)="checkEntityName()"
                 (input)="valueChanged()" placeholder="Entity Name"
                 formControlName="entityname"
                     required
                    maxlength="100">
            </label>
        </div>
    </div>
    <div class="form-error-sign error-message" *ngIf="entitynameNoError">
        <p>Entity Name is already in use.</p>
    </div>
    <div id="container">
       

            

            
        <div id="contentC">
            <label>
                 <b> EIN</b>
               
                <input class="black-input opposite-colors" type="text" no-special-chars="#!$%^<>+='" formControlName="ein"
                placeholder="EIN"
                    maxlength="20">
            </label>
        </div>
    </div>
    <div id="container">
       

            

            
        <div id="contentC">
            <label>
                 <b>Business Activity Code</b>
               
                <input class="black-input opposite-colors" type="text" no-special-chars="#!$%^<>+='" formControlName="businessactivitycode"
                placeholder="Business Activity Code"
                    maxlength="20">
            </label>

        </div>

       
    </div>
</section>
<footer class="endFormSubmit info-tile">
    <button type='button' class="btn btn-success" [disabled]="!targetForm.valid || isDisabled 
    || entitynameNoError || !isEntityValueEntered"
       (click)="AddEntity()" >Add Entity</button> &nbsp;
    <button class="btn kpmg-button--flat" (click)="rightSideDrawerService.closeRightSideDrawer()
    ;resetRightSideDrawerDataAdd()">Cancel</button>
</footer>
</form>